/* ============================================
   NEXTAP THEME JS
   Core theme functionality
   ============================================ */

(function() {
  'use strict';

  /* --- Scroll reveal animations --- */
  function initRevealAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const reveals = document.querySelectorAll('.nxt-reveal, .nxt-scale-in');
    if (!reveals.length) return;

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nxt-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });

    reveals.forEach(function(el) { observer.observe(el); });
  }

  /* --- Accordion (FAQ) --- */
  function initAccordions() {
    document.querySelectorAll('.nxt-accordion').forEach(function(accordion) {
      accordion.querySelectorAll('.nxt-accordion__trigger').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var item = this.closest('.nxt-accordion__item');
          var isOpen = item.hasAttribute('open');
          if (!isOpen) {
            item.setAttribute('open', '');
            this.setAttribute('aria-expanded', 'true');
          } else {
            item.removeAttribute('open');
            this.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  }

  /* --- Smooth scroll for anchor links --- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerH = document.querySelector('.nxt-header') ?
            document.querySelector('.nxt-header').offsetHeight : 0;
          var top = target.getBoundingClientRect().top + window.scrollY - headerH - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  /* --- Cart functionality (AJAX) --- */
  window.NxtCart = {
    add: function(formData) {
      return fetch(window.routes.cart_add_url, {
        method: 'POST',
        body: formData
      }).then(function(r) { return r.json(); });
    },

    get: function() {
      return fetch(window.routes.cart_url + '.js')
        .then(function(r) { return r.json(); });
    },

    updateCount: function(count) {
      document.querySelectorAll('.nxt-cart-count').forEach(function(el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
    },

    refresh: function() {
      var self = this;
      this.get().then(function(cart) {
        self.updateCount(cart.item_count);
      });
    }
  };

  /* --- Product form submission --- */
  function initProductForms() {
    document.querySelectorAll('.nxt-product-form').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.nxt-product-form__submit');
        var btnText = btn.querySelector('.nxt-product-form__submit-text');
        var originalText = btnText ? btnText.textContent : '';

        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('nxt-btn--loading');
        if (btnText) btnText.textContent = '';

        var formData = new FormData(form);

        window.NxtCart.add(formData).then(function(item) {
          if (item.status && item.status === 422) {
            var errorEl = form.querySelector('.nxt-product-form__error');
            if (errorEl) {
              errorEl.textContent = item.description || item.message;
              errorEl.style.display = 'block';
            }
          } else {
            window.NxtCart.refresh();
            var cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              var drawerEl = document.getElementById('CartDrawer');
              if (drawerEl) {
                drawerEl.classList.add('is-open', 'active');
                document.body.classList.add('overflow-hidden');
              }
            }
          }
        }).catch(function() {
          var errorEl = form.querySelector('.nxt-product-form__error');
          if (errorEl) {
            errorEl.textContent = 'Bir hata oluştu. Lütfen tekrar deneyin.';
            errorEl.style.display = 'block';
          }
        }).finally(function() {
          btn.removeAttribute('disabled');
          btn.classList.remove('nxt-btn--loading');
          if (btnText) btnText.textContent = originalText;
        });
      });
    });
  }

  /* --- Variant picker --- */
  function initVariantPickers() {
    document.querySelectorAll('.nxt-variant-picker').forEach(function(picker) {
      var productJson = picker.querySelector('[data-product-json]');
      if (!productJson) return;

      var product;
      try { product = JSON.parse(productJson.textContent); }
      catch (e) { return; }

      var options = picker.querySelectorAll('.nxt-variant-option');
      var priceEl = picker.closest('.nxt-product-info') ?
        picker.closest('.nxt-product-info').querySelector('.nxt-price__current') : null;
      var compareEl = picker.closest('.nxt-product-info') ?
        picker.closest('.nxt-product-info').querySelector('.nxt-price__compare') : null;
      var addBtn = picker.closest('form') ?
        picker.closest('form').querySelector('.nxt-product-form__submit') : null;
      var variantInput = picker.closest('form') ?
        picker.closest('form').querySelector('input[name="id"]') : null;

      options.forEach(function(opt) {
        opt.addEventListener('click', function() {
          options.forEach(function(o) { o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false'); });
          this.classList.add('is-active');
          this.setAttribute('aria-checked', 'true');

          var selectedOptions = [];
          picker.querySelectorAll('.nxt-variant-option.is-active').forEach(function(active) {
            selectedOptions.push(active.getAttribute('data-value'));
          });

          var variant = product.variants.find(function(v) {
            return v.options.every(function(o, i) {
              return !selectedOptions[i] || o === selectedOptions[i];
            });
          });

          if (variant) {
            if (variantInput) variantInput.value = variant.id;
            if (priceEl) priceEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(variant.price) : (variant.price / 100).toFixed(2) + ' TL';
            if (compareEl) {
              if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                compareEl.textContent = Shopify.formatMoney ? Shopify.formatMoney(variant.compare_at_price) : (variant.compare_at_price / 100).toFixed(2) + ' TL';
                compareEl.style.display = '';
              } else {
                compareEl.style.display = 'none';
              }
            }
            if (addBtn) {
              var btnText = addBtn.querySelector('.nxt-product-form__submit-text');
              if (variant.available) {
                addBtn.removeAttribute('disabled');
                if (btnText) btnText.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Sepete Ekle';
              } else {
                addBtn.setAttribute('disabled', 'disabled');
                if (btnText) btnText.textContent = window.variantStrings ? window.variantStrings.soldOut : 'Tükendi';
              }
            }

            var url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        });
      });
    });
  }

  /* --- Initialize --- */
  function init() {
    initRevealAnimations();
    initAccordions();
    initSmoothScroll();
    initProductForms();
    initVariantPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      initRevealAnimations();
      initAccordions();
      initProductForms();
      initVariantPickers();
    });
  }
})();
